import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [mockOtp, setMockOtp] = useState("");

  const sendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/forgot", { mobile });
      if (r.data.mock_otp) setMockOtp(r.data.mock_otp);
      toast.success("OTP sent via WhatsApp (mocked).");
      setStep(2);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send OTP");
    } finally { setLoading(false); }
  };
  const reset = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) return toast.error("Password must be at least 6 characters");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { mobile, otp, new_password: newPassword });
      toast.success("Password reset successful");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <Card className="w-full max-w-md p-8 border-slate-200">
        <h2 className="text-2xl font-semibold tracking-tight" style={{ fontFamily: "Outfit, sans-serif" }}>Reset password</h2>
        <p className="text-sm text-slate-500 mt-1">We'll send an OTP via WhatsApp to verify your identity.</p>
        {step === 1 ? (
          <form onSubmit={sendOtp} className="mt-6 space-y-4">
            <div>
              <Label>Mobile Number</Label>
              <Input data-testid="forgot-mobile-input" value={mobile} onChange={(e) => setMobile(e.target.value)} className="mt-1.5" inputMode="numeric" />
            </div>
            <Button data-testid="forgot-send-otp-button" disabled={loading} className="w-full btn-brand">
              {loading ? "Sending…" : "Send OTP"}
            </Button>
          </form>
        ) : (
          <form onSubmit={reset} className="mt-6 space-y-4">
            {mockOtp && (
              <div className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md p-2">
                Dev mode (WhatsApp mocked) — OTP: <span className="font-mono font-semibold">{mockOtp}</span>
              </div>
            )}
            <div>
              <Label>OTP</Label>
              <Input data-testid="forgot-otp-input" value={otp} onChange={(e) => setOtp(e.target.value)} className="mt-1.5" inputMode="numeric" />
            </div>
            <div>
              <Label>New Password</Label>
              <PasswordInput data-testid="forgot-new-password-input" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} className="mt-1.5" />
            </div>
            <Button data-testid="forgot-reset-button" disabled={loading} className="w-full btn-brand">
              {loading ? "Resetting…" : "Reset Password"}
            </Button>
          </form>
        )}
        <div className="text-center text-sm mt-6">
          <Link to="/login" className="text-[#fd7e14] hover:underline">Back to login</Link>
        </div>
      </Card>
    </div>
  );
}
